import NotFoundErrorPage from '@atlassian/jira-error-pages/src/ui/not-found-error-page/NotFoundErrorPage.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export default NotFoundErrorPage;
